// common/apiClient.js
import axios from "axios";
import { toast } from "react-toastify";

// Create a navigation handler that will be set by your App component
let navigationHandler = null;

export const setNavigationHandler = (handler) => {
  navigationHandler = handler;
};

// Custom error class for auth failures
class AuthError extends Error {
  constructor(message) {
    super(message);
    this.name = 'AuthError';
  }
}

// Create Axios instance without baseURL
const api = axios.create({});

// Request Interceptor — inject token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("ata");
    
    // Check if token exists for protected routes
    const publicPaths = ["/", "/login","/sign-up", "/un-authorized", "/register", "/forgot-password", "/reset-password", "/not-found", "/careers/offers"];
    const currentPath = window.location.pathname;

    // Check if current path starts with any public path
    const isPublic = publicPaths.some(
      (path) =>
        currentPath === path ||
        (path === "/reset-password" && currentPath.startsWith("/reset-password"))
    );
    
    // If no token and trying to access protected route
    if (!token && !isPublic) {
      // Navigate immediately
      const navigate = () => {
        if (navigationHandler) {
          navigationHandler("/un-authorized");
        } else {
          window.location.href = "/un-authorized";
        }
      };
      
      // Execute navigation asynchronously to avoid blocking
      Promise.resolve().then(navigate);
      
      // Reject the request immediately
      return Promise.reject(new AuthError("No authentication token found"));
    }
    
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response Interceptor — handle 401 / 403 globally
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Skip processing for auth errors from request interceptor
    if (error instanceof AuthError) {
      return Promise.reject(error);
    }
    
    // Don't process cancelled requests
    if (axios.isCancel(error)) {
      return Promise.reject(error);
    }

    const status = error?.response?.status;
    const currentPath = window.location.pathname;
    
    if (status === 401) {
      // Clear token for 401
      if (status === 401) {
        localStorage.removeItem("ata");
      }
      
      // Navigate to un-authorized page
      if (currentPath !== "/un-authorized") {
        const navigate = () => {
          if (navigationHandler) {
            navigationHandler("/un-authorized");
          } else {
            window.location.href = "/un-authorized";
          }
        };
        
        Promise.resolve().then(navigate);
      }
    } else {
      // Show error toast for other errors
      toast.error(error?.response?.data?.message || "Something went wrong");
    }
    
    return Promise.reject(error);
  }
);

export default api;
